import { useCallback, useState } from 'react';
import { AlertColor } from '@mui/material';

interface SnackbarState {
  isOpen: boolean;
  message: string;
  type: AlertColor;
}

export const useSnackbar = () => {
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    isOpen: false,
    message: '',
    type: 'success',
  });

  const showSnackbar = useCallback((message: string, type: AlertColor = 'success') => {
    setSnackbar({ isOpen: true, message, type });
  }, []);

  const closeSnackbar = useCallback(() => {
    setSnackbar((prev) => ({ ...prev, isOpen: false }));
  }, []);

  return {
    snackbar,
    showSnackbar,
    closeSnackbar,
  };
};